import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80b06adc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-tendency__price-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "price-tendency__status"
}
const _hoisted_3 = { class: "progress" }
const _hoisted_4 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_5 = {
  key: 0,
  class: "price-tendency__progress-description mt-2"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "col-1 d-flex align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-popover btn-popover--grey" }, "i", -1))
const _hoisted_10 = {
  key: 1,
  class: "price-tendency__additional"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.priceTendencyConfig.percentage ? 'price-tendency ' + _ctx.priceTendencyConfig.priceTendency : 'text-end position-relative')
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.translate('shop.configuration.Price-per-Adult')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(["price-tendency__price", _ctx.isLoadingPrice ? 'price-tendency--loading' : ''])
            }, _toDisplayString(_ctx.priceTendencyConfig.pricePerAdult?.toFixed(2)), 3)
          ]),
          (_ctx.priceTendencyConfig.percentage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle(_ctx.stylePercentage(_ctx.priceTendencyConfig.percentage)),
                    "aria-valuenow": _ctx.priceTendencyConfig.percentage,
                    "aria-valuemin": "0",
                    "aria-valuemax": _ctx.priceTendencyConfig.percentage
                  }, null, 12, _hoisted_4)
                ]),
                (_ctx.priceTendencyConfig.percentageDescription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.priceTendencyConfig.percentageDescription), 1),
                        (_ctx.priceTendencyConfig.percentageDescriptionInfo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_Popper, null, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.priceTendencyConfig.percentageDescriptionInfo ? _ctx.priceTendencyConfig.percentageDescriptionInfo : ''), 1)
                                ]),
                                default: _withCtx(() => [
                                  _hoisted_9
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.priceTendencyConfig.additionalPriceInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.priceTendencyConfig.additionalPriceInfo), 1))
            : _createCommentVNode("", true)
        ], 2)
      ], 512), [
        [_vShow, _ctx.priceTendencyConfig && !_ctx.priceTendencyConfig.noAvailableDates]
      ])
    ]),
    _: 1
  }))
}